/** Mevcut pixel oturumunu sepete taşır; kimlik veya izin üretmez. */
(() => {
  const marker = Symbol.for('tim.atif.koprusu.v1');
  if (window[marker]) return;
  window[marker] = true;
  const key = 'tim.behavior.context.v1';
  let timer, running = false, paused = false, refreshPending = false, checked, attemptKey, attempts = 0;
  let privacyRequested = false;

  function desired() {
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return '';
      const value = JSON.parse(sessionStorage.getItem(key));
      return /^att_[A-Za-z0-9_-]{20,60}$/.test(value?.att_ref || '') &&
        Date.parse(value.expires_at) > Date.now() ? value.att_ref : '';
    } catch { return ''; } // Bilinmeyen izin/storage yeni aktarımı kapatır.
  }

  async function cart(path, attributes) {
    const abort = new AbortController();
    const timeout = setTimeout(() => abort.abort(), 5000);
    try {
      const root = window.Shopify?.routes?.root;
      if (typeof root !== 'string' || !root.startsWith('/') || root.startsWith('//')) throw Error('CART_ROUTE');
      const response = await fetch(root + path, {
        method: attributes ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        signal: abort.signal,
        ...(attributes ? {headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes})} : {}),
      });
      if (!response.ok) throw Error('CART_UNAVAILABLE');
      return await response.json();
    } finally { clearTimeout(timeout); }
  }

  function schedule() {
    clearTimeout(timer);
    // Pixel storage ACK için DOM olayı yoktur. Görünür sayfada yalnız küçük
    // mevcut kaydı kontrol eder; değişmeyen state için network isteği üretmez.
    if (!paused && !document.hidden) timer = setTimeout(sync, 1000);
  }

  async function sync() {
    if (running || paused) return;
    if (!privacyRequested && !window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
      privacyRequested = true;
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => { void sync(); });
    }
    const target = desired();
    if (target !== attemptKey) { attemptKey = target; attempts = 0; }
    if (checked === target || attempts >= 3) { schedule(); return; }
    running = true;
    attempts++;
    try {
      const before = await cart('cart.js');
      if (paused) return;
      // İlk ürünün gerçek readback'ini bekle; boş sepet için ayrı bir cart
      // oluşturma yazımı başlatma. Add-to-cart kendi yaşam döngüsünü tamamlar.
      // Boş sepette izin geri alma server tombstone ile korunur; ilk dolu
      // readback'te stale attribute temizlenir. Checkout hiçbir zaman bekletilmez.
      if (!Number.isSafeInteger(before.item_count) || before.item_count < 1) {
        checked = desired();
        return;
      }
      // GET sırasında izin/session değiştiyse eski referansı hiç yazma.
      const current = desired();
      if ((before.attributes?._tim_att || '') !== current) {
        // Standard updateCart attributes bütün kümeyi değiştirir. Ajax yalnız
        // bu anahtarı günceller; diğer uygulamaların attributes alanları korunur.
        await cart('cart/update.js', {_tim_att: current});
        const after = await cart('cart.js');
        if ((after.attributes?._tim_att || '') !== current) throw Error('CART_READBACK');
      }
      checked = current;
    } catch {
      // Checkout/add-to-cart engellenmez. Sınırlı retry; başarı olayı üretilmez.
      checked = undefined;
    } finally {
      running = false;
      const refreshRequested = refreshPending;
      if (refreshPending) {
        refreshPending = false;
        checked = undefined;
        attempts = 0;
      }
      // Uçuşta POST sırasında revoke geldiyse seri telafi yazımı yap.
      if (!paused && (refreshRequested || desired() !== attemptKey)) { void sync(); }
      else schedule();
    }
  }

  function refresh() {
    checked = undefined;
    attempts = 0;
    if (running) refreshPending = true;
    else void sync();
  }
  document.addEventListener('visitorConsentCollected', refresh);
  // Standard events işlem başında yayınlanır; ACK promise tamamlandıktan sonra oku.
  for (const name of ['shopify:cart:lines-update', 'shopify:cart:attributes-update']) {
    document.addEventListener(name, event => {
      Promise.resolve(event.promise).then(refresh, refresh);
    });
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) clearTimeout(timer);
    else refresh();
  });
  window.addEventListener('pagehide', () => { paused = true; clearTimeout(timer); });
  window.addEventListener('pageshow', () => { paused = false; refresh(); });
  void sync();
})();
